'use strict';

var Navigation = function () {
	$(function () {
		$('.book-depth-1 li').each(function (i, v) {
            var $this = $(v),
                hasSecondLevel = $this.find('.book-depth-2').length;
            
            if (!hasSecondLevel) {
                $this.find('.book-depth-1-accordion').remove();
			};

			

			
		});


		$('.book-depth-1-accordion').on('click', function (e) {
			var $this = $(this),
				$parent = $this.parent();

			$this.toggleClass("close");
			$parent.find('.book-depth-2').toggleClass('book-depth-2-active');
		});
	});

	$(function (){
		$('.book-depth-1 li').each(function (i, v) {
            var $this = $(v),
                hasSecondLevel = $this.find('.book-depth-2').length;
            
			if (hasSecondLevel) {
				console.log("YAS1")
				
				if($this.find('a').hasClass("is-active")){
					console.log("YAS2")
					$(".is-active").closest(".book-depth-2").addClass("book-depth-2-active");
					$(".book-depth-2-active").siblings("span").addClass("close");
					// $(".book-depth-1-accordion").addClass("close");
				}
				// $this.find('.is-active').parent().addClasslass("book-depth-2-active");

			};	
		});
	});

	$(function () {
		$('.book-depth-1 li').each(function (i,v){
			var $this = $(v);

			if($this.find('a').hasClass("is-active")){

				// $this.find("")
				$(".is-active").next('.book-depth-2').addClass("book-depth-2-active");
				$(".book-depth-2-active").siblings("span").addClass("close");

			}
		});
	});
	$(function () {
		$(".mobile-menu-click").on('click', function (e) {
			e.preventDefault();
			var $this = $(this),
			$parent = $this.parent();

			$this.toggleClass("active");			

			if ($(".aspi-book-side-navigation").hasClass('aspi-book-side-navigation-active')) {
				$(".aspi-book-side-navigation").removeClass("aspi-book-side-navigation-active");
			} else {
				$(".aspi-book-side-navigation").addClass("aspi-book-side-navigation-active");

			}

		})
    });
    
    $(function(){
		$(".aspi-book-side-navigation").prepend("<div class='aspi-book-side-navigation-headers'> </div>")
        $("header .o-pageHead__share").clone().prependTo(".aspi-book-side-navigation-headers")
        $(".block-aspi-book-program-logo").clone().prependTo(".aspi-book-side-navigation-headers")

    });
};



module.exports = Navigation;
